var map = {
	"./aqua3.png": "8f6d",
	"./blue3.png": "b381",
	"./indigo3.png": "2662",
	"./maroon3.png": "c33e",
	"./orange3.png": "596a",
	"./pink3.png": "3755"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e0e";